export default "__VITE_ASSET__CkaRxPbz__"